/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const car_1_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2.25 19.749a1.5 1.5 0 0 0 3 0v-1.5m-3 1.5V18.25m0 1.499V18.25m19.5-.001a1.5 1.5 0 0 0 1.5-1.5v-1.5m-1.5 3h-3m3 0v1.5a1.5 1.5 0 1 1-3 0v-1.5m-15-8.999 16.5.005M3.75 9.25l-1.5-1.5H.75m3 1.5-2.47 2.47a1.81 1.81 0 0 0-.367.529M3.75 9.25l1.723-4.595A2.166 2.166 0 0 1 7.5 3.25h9a2.166 2.166 0 0 1 2.027 1.405l1.723 4.6m-18 8.995a1.5 1.5 0 0 1-1.5-1.5v-1.501m1.5 3.001h3m15-8.995 2.47 2.466c.154.154.278.333.366.528M20.25 9.255l1.5-1.505h1.5m-13.125 7.499L8.967 13.4a.75.75 0 0 1 .633-1.151h4.8a.752.752 0 0 1 .636 1.148l-1.158 1.852m-9.842-3a.75.75 0 0 1 .671 1.086l-.128.256A3 3 0 0 1 1.9 15.249H.75m3.286-3H.913m3.123 0H.913m0 0c-.106.234-.163.49-.163.751v2.249m22.336-3c.107.234.164.49.164.751v2.249m-.164-3h-3.122a.75.75 0 0 0-.671 1.086l.128.256a3 3 0 0 0 2.679 1.658h1.15m-18 3h13.5"
    />
  </svg>
)
export default car_1_medium
